import { useMemo } from "react";
import Select from "react-select";

//Props Validations
import PropTypes from "prop-types";

// styles
import ReactSelectStyles from "styles/ReactSelectStyles";

// redux
import { useDispatch, useSelector } from "react-redux";
import { loadScoreDistributionSelectedVariableOverallState, loadScoreDistributionSelectedVariableAdditionalState } from "store/features/analysisResultsSlice";

const ScoreDistributionVariableSelect = ({ dataMappingData, productsSecondaryDataState, scoreDistributionSelectedVariable, moduleName }) => {
    const dispatch = useDispatch();
    const removedKpiStoreState = useSelector((state) => state.analysisKpiStore[`${moduleName}RemovedKpiList`]);

    const hasValidMean = (score) => score.mean !== null && score.mean !== "";

    const productHasBackendVariable = (backendVariable) => (product) => product.scores?.some((score) => score.backendVariable === backendVariable && hasValidMean(score));

    const isSubCategoryVisible = (sub) => productsSecondaryDataState.some(productHasBackendVariable(sub.backendVariable));

    const isSubCategoryVisibleAndNotRemoved = (sub) => !removedKpiStoreState.includes(sub.backendVariable) && isSubCategoryVisible(sub);

    const variableOptions = useMemo(() => {
        return dataMappingData
            .map((macro) => {
                const validSubCategories = macro.displayLabels.filter(isSubCategoryVisibleAndNotRemoved);

                return validSubCategories;
            })
            .flatMap((inner) =>
                inner.map(({ backendVariable, displayLabel }) => ({
                    value: backendVariable,
                    label: displayLabel,
                }))
            );
    }, [dataMappingData, productsSecondaryDataState, moduleName]);

    const handleChange = (selectedOption) => {
        if (moduleName === "overall") {
            dispatch(loadScoreDistributionSelectedVariableOverallState(selectedOption));
        } else {
            dispatch(loadScoreDistributionSelectedVariableAdditionalState(selectedOption));
        }
    };

    return (
        <Select
            value={scoreDistributionSelectedVariable}
            placeholder={"Select The Variable"}
            options={variableOptions}
            onChange={handleChange}
            styles={ReactSelectStyles}
            isSearchable={false}
        />
    );
};

ScoreDistributionVariableSelect.propTypes = {
    dataMappingData: PropTypes.object,
    productsSecondaryDataState: PropTypes.object,
    scoreDistributionSelectedVariable: PropTypes.object,
    moduleName: PropTypes.string,
};

export default ScoreDistributionVariableSelect;
